export const OFFERS_LIST_FETCH_ERROR = 'Ошибка при получении списка предложений';
export const OFFERS_MARK_READ_ERROR = 'Ошибка при отметке как прочитанные';
export const NOTIFICATION_MESSAGE_SUBTITLE = 'Отправил сообщение';
export const NOTIFICATION_RECRUIT_SUBTITLE = 'Предложение о сотрудничестве';
